import { useProfileEntity } from '#reducers/profile';
import { useCurrentEnvironmentKey } from '#reducers/projects';
import type { Flag } from '#utils/flags/records/Flag';

export function useCheckAccessForFlagInCurrentEnvironment(flag: Flag) {
  const envKey = useCurrentEnvironmentKey();
  const profile = useProfileEntity();
  return flag.checkAccess({ envKey, profile });
}
